import CircularProgress from '@material-ui/core/CircularProgress';
import GlobalStyles from './components/GlobalStyles';
import React, {Suspense, useEffect} from 'react';
import routes from './routes';
import theme from './theme';
import {fetchConfigurationGlobal, fetchSettingOperational} from 'store/global.slice';
import {fetchUserDetail, fetchUserSetting} from 'store/user.slice';
import {get, isEmpty} from 'lodash';
import {getCurrentUser} from 'store/actions/authActions';
import {hasVipDomain} from 'utils/common.util';
import {ThemeProvider} from '@material-ui/core';
import {ToastContainer} from 'react-toastify';
import {useDispatch, useSelector} from 'react-redux';
import {useRoutes} from 'react-router-dom';

import './App.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  // const {setting} = props;
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.user?.profile?.uuid);
  const operation = useSelector(state => state.global.operation);
  const routing = useRoutes(routes(!isEmpty(currentUser), operation, hasVipDomain));
  const setting = useSelector(state => get(state, 'user.setting.data', {}));
  // const configurations = useSelector(state => get(state, 'global.configurations.data', []));

  useEffect(() => {
    getCurrentUser(dispatch);

    const promise = !isEmpty(currentUser) && dispatch(fetchUserDetail());
    const promiseSettingOperational = isEmpty(operation) && dispatch(fetchSettingOperational());
    let promiseSetting;
    if (isEmpty(setting) && !isEmpty(currentUser)) {
      promiseSetting = dispatch(fetchUserSetting());
    }

    // Private
    const promiseConfig = dispatch(fetchConfigurationGlobal());

    return () => {
      promise && promise.abort();
      promiseSetting && promiseSetting.abort();
      promiseSettingOperational && promiseSettingOperational.abort();
      promiseConfig && promiseConfig.abort();
    };
  }, [currentUser]);

  // console.log(`!isEmpty(currentUser)`, !isEmpty(currentUser));
  return (
    <ThemeProvider theme={theme}>
      <ToastContainer
        autoClose={2000}
        role="alert"
        position="bottom-left"
        hideProgressBar
        closeOnClick
        pauseOnHover={false}
        draggable={false}
        theme="dark"
        className="online-user-toast"
        toastClassName="custom-toast"
        // progressClassName="fancy-progress-bar"
      />
      <GlobalStyles />
      <Suspense
        fallback={
          <div className="flex flex-col justify-center items-center h-full bg-black">
            <CircularProgress />
            <span>Loading..</span>
          </div>
        }>
        {routing}
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
